<ng-container *ngIf="isLoaded"><div class="p-4" [innerHtml]="content"></div></ng-container>
 